module.exports = __webpack_public_path__ + "img/20191206165749360截图20191206104207845.8b07bd22.jpg";